import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  l,
  IptC,
  LblC,
  GridC,
  TextC,
} from 'lib';
*/
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';
import * as ihd from './ihd';

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    i1zz: ht.dz,
  }
}) => {

//hf.l(`icvI1zS11Co3a 25: here`);
  return (
    cr.c(GridC.N, {
      key: -20,
      abtType: 'nolineCmnz',
      lineCs: [
        {
          cellCs: [
            {
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  boxStlz: a('bc/lt9 bwb/1 pb/0.5'),
                  lblCz: {
                    abtType: 'hzlStfz',
                    textz: {
                      pfx: '団体名：',
                    }
                  },
                  cttCz: {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      hf.f(pz.cz.i1zz?.i15rz?.i15ra4100s) ?
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'altCmnz',
                        boxStlz: a('mr/1'),
                        textz: {
                          pfx: pz.cz.i1zz?.i15rz?.i15ra4100s,
                          stlz: a('ts/l')
                        }
                      })
                      : null,
                      cr.c(IptC.S, {
                        key: -20,
                        cz: {
                          bEdit: false,
                          iptType: 'text',
//                          vle: spl.rsvz['団体'],
                          vle: pz.cz.i1zz?.i18rz?._pfx,
                        }
                      }),
                    ],
                  }
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  lblCz: {
                    abtType: 'hzlStfz',
                    textz: {
                      pfx: '団体番号：',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        cz: {
                          bEdit: false,
                          iptType: 'text',
                          vle: pz.cz.i1zz?.i18rz?.i18rab100s,
                        }
                      })
                    ],
                  }
                }),
              ]
            },
            {
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  lblCz: {
                    abtType: 'hzlStfz',
                    textz: {
                      pfx: '団体登録日：',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        cz: {
                          bEdit: false,
                          iptType: 'dtm',
                          vle: String(pz.cz.i1zz?.i18rz?.createdAt ?? '').substring(0, 10),
                        }
                      })
                    ],
                  }
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  lblCz: {
                    abtType: 'hzlStfz',
                    textz: {
                      pfx: '代表者：',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        cz: {
                          bEdit: false,
                          iptType: 'text',
                          vle: pz.cz.i1zz?.i18rz?.i18ra2110s,
                        }
                      })
                    ],
                  }
                }),
              ]
            },
            {
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  lblCz: {
                    abtType: 'hzlStfz',
                    textz: {
                      pfx: '利用制限：',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        cz: {
                          bEdit: false,
                          iptType: 'pcr',
                          ls: ihd.f('i18rt1100i').ls,
                          vle: pz.cz.i1zz?.i18rz?.i18rt1100i,
                        }
                      })
                    ],
                  }
                }),
              ]
            },
          ]
        },
      ]
    })
  );
};
